"use client";

import { useTranslations } from "next-intl";

import { Select } from "@/components/form/select";
import { AnnouncementCategory } from "@/contexts/queries/announcements";

import { useCategory } from "../use-category";

interface CategorySelectProps {
  selectedCategory: AnnouncementCategory | null;
}

type CategoryValue = AnnouncementCategory | "all";

interface CategoryOption {
  value: CategoryValue;
  label: string;
}

export function CategorySelect({ selectedCategory }: CategorySelectProps) {
  const t = useTranslations("announcements");
  const { setCategory } = useCategory();

  const categoryOptions: CategoryOption[] = [
    { value: "all", label: t("categories.allAnnouncements") },
    { value: "listings", label: t("categories.newMarkets") },
    { value: "delistings", label: t("categories.delistedMarkets") },
    { value: "parameter-updates", label: t("categories.parameterUpdates") },
    { value: "product-updates", label: t("categories.productUpdates") },
    { value: "community", label: t("categories.community") },
  ];

  const currentValue = selectedCategory ?? "all";

  const handleChange = (value: CategoryValue) => {
    if (value === "all") {
      setCategory(null);
    } else {
      setCategory(value);
    }
  };

  return <Select value={currentValue} options={categoryOptions} onChange={handleChange} />;
}
